import { render, staticRenderFns } from "./app-checkbox-group.vue?vue&type=template&id=c9cc482c&scoped=true&"
import script from "./app-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./app-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./app-checkbox-group.vue?vue&type=style&index=0&id=c9cc482c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cc482c",
  null
  
)

export default component.exports